import { useParams, Navigate } from "react-router-dom";
import { PageHero } from "../components/shared";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Airanet India Pvt Ltd respects your privacy. This placeholder policy explains how enquiry and application data submitted through this website is collected, used and stored.",
      "We collect only the information you provide through our forms (such as name, contact details and messages) in order to respond to enquiries and process job applications.",
      "Data is stored securely and is not sold to third parties. You may request access to, correction of, or deletion of your data by contacting us.",
      "This is placeholder legal wording and should be reviewed and finalised by the company before publication.",
    ],
  },
  terms: {
    title: "Website Terms of Use",
    body: [
      "By accessing this website you agree to use it for lawful purposes only. Content is provided for general information about Airanet India Pvt Ltd.",
      "All content, trademarks and materials remain the property of Airanet India Pvt Ltd unless otherwise stated.",
      "This is placeholder wording pending final legal review.",
    ],
  },
  cookies: {
    title: "Cookie Policy",
    body: [
      "This website uses cookies to improve your browsing experience and understand how the site is used.",
      "You can accept or dismiss non-essential cookies via the cookie banner. Essential cookies are required for the site to function.",
      "This is placeholder wording pending final legal review.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      "Information on this website is provided in good faith for general information only. Statistics, project figures, certifications and geographic coverage shown as placeholders are illustrative and subject to confirmation.",
      "Airanet India Pvt Ltd makes no warranties regarding completeness or accuracy of placeholder content until finalised.",
    ],
  },
};

const Legal = () => {
  const { doc } = useParams();
  const c = CONTENT[doc];
  if (!c) return <Navigate to="/" replace />;
  return (
    <>
      <PageHero overline="Legal" title={c.title} />
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-5 md:px-8 space-y-5 text-[#64748B] text-lg leading-relaxed">
          {c.body.map((p, i) => <p key={i}>{p}</p>)}
          <p className="text-sm italic">Equal Opportunities & Health and Safety statements available on request.</p>
        </div>
      </section>
    </>
  );
};

export default Legal;
